<section [formGroup]="stepForm">
  <mbs-card [size]="MbsSize.sm">
    <mbs-card-group>
      <mbs-form-group class="mb-0">
        <mbs-radio
          formControlName="backupAllFiles"
          name="backupAllFiles"
          [id]="'backup-all-files-radio-0'"
          [label]="'wizards:backup_in_selected_label' | i18next"
          [value]="0"
          (change)="backupAllFilesChangeHandler($event)"></mbs-radio>
        <mbs-radio
          formControlName="backupAllFiles"
          name="backupAllFiles"
          [descriptionOutside]="false"
          [id]="'backup-all-files-radio-1'"
          [label]="'wizards:backup_types_label' | i18next"
          [value]="1"
          (change)="backupAllFilesChangeHandler($event)">
          <ng-container appendLabel>
            <span
              class="cursor-help fa fa-info-circle text-info ml-2"
              [ngbTooltip]="'wizards:backup_types_tooltip' | i18next"></span>
          </ng-container>
          <ng-template
            radioDescription
            [hide]="stepForm.get('backupAllFiles').value !== 1">
            <mbs-input
              formControlName="includeMask"
              name="includeMask"
              [id]="'include-mask-input'"
              [validationWhitespace]="true"></mbs-input>
          </ng-template>
        </mbs-radio>
        <mbs-radio
          formControlName="backupAllFiles"
          name="backupAllFiles"
          [descriptionOutside]="false"
          [id]="'backup-all-files-radio-2'"
          [label]="'wizards:not_backup_types_label' | i18next"
          [value]="2"
          (change)="backupAllFilesChangeHandler($event)">
          <ng-container appendLabel>
            <span
              class="cursor-help fa fa-info-circle text-info ml-2"
              [ngbTooltip]="'wizards:not_backup_types_tooltip' | i18next"></span>
          </ng-container>
          <ng-template
            radioDescription
            [hide]="stepForm.get('backupAllFiles').value !== 2">
            <mbs-input
              formControlName="excludeMask"
              name="excludeMask"
              [id]="'exclude-mask-input'"
              [validationWhitespace]="true"></mbs-input>
          </ng-template>
        </mbs-radio>
      </mbs-form-group>
    </mbs-card-group>
    <mbs-card-group>
      <mbs-form-group [class.mb-0]="isUnix && !isNetBuild">
        <div class="form-row">
          <div class="col-3">
            <mbs-checkbox
              formControlName="skipFolders"
              [id]="'skip-folders-checkbox'"
              [label]="'wizards:skip_folders_label' | i18next"
              (change)="skipFoldersChangeHandler($event)">
              <ng-container appendLabel>
                <span
                  class="cursor-help fa fa-info-circle text-info ml-2"
                  container="body"
                  tooltipClass="tooltip-lg"
                  [ngbTooltip]="'wizards:skip_folders_tooltip' | i18next"></span>
              </ng-container>
            </mbs-checkbox>
          </div>
          <div
            *ngIf="canBackupEmptyFolders"
            class="col-9">
            <mbs-checkbox
              formControlName="BackupEmptyFolders"
              [id]="'backup-empty-checkbox'"
              [label]="'wizards:backup_empty_label' | i18next"></mbs-checkbox>
          </div>
        </div>
        <div
          *ngIf="stepForm.get('skipFolders').value"
          class="mbs-check_description -inside mt-3">
          <mbs-input
            formControlName="skipFolderName"
            name="skipFolderName"
            [id]="'skip-folder-name'"
            [validationWhitespace]="true"></mbs-input>
        </div>
      </mbs-form-group>

      <ng-container *ngIf="!isUnix || isNetBuild">
        <mbs-form-group>
          <div class="form-row align-items-center">
            <div class="col-4">
              <mbs-checkbox
                formControlName="backupFilesModified"
                [id]="'backup-files-modified-checkbox'"
                [label]="'wizards:backup_modified_label' | i18next"
                (change)="backupFilesModifiedChangeHandler($event)"></mbs-checkbox>
            </div>
            <div class="col-2">
              <mbs-number
                formControlName="daysAgo"
                [id]="'days-ago-input-number'"
                [min]="1"></mbs-number>
            </div>
            <div class="col-3">
              <label
                class="mbs-form_label mb-0"
                for="days-ago-input-number"
                [class.-disabled]="!stepForm.get('backupFilesModified').value"
                >{{ 'wizards:days_ago_label' | i18next }}</label
              >
              <span
                class="cursor-help fa fa-info-circle text-info ml-2"
                [ngbTooltip]="'wizards:days_ago_tooltip' | i18next"></span>
            </div>
          </div>
        </mbs-form-group>

        <mbs-form-group>
          <div class="form-row align-items-center">
            <div class="col-5">
              <mbs-checkbox
                formControlName="backupFilesModifiedSince"
                [id]="'backup-files-modified-since-checkbox'"
                [label]="'wizards:backup_modified_since_label' | i18next"
                (change)="backupFilesModifiedSinceChangeHandler($event)"></mbs-checkbox>
            </div>
            <div class="col-3">
              <mbs-datepicker
                formControlName="date"
                [id]="'backup-files-modified-since-date-picker'"
                [needSetCurrent]="true"></mbs-datepicker>
            </div>
            <div class="col-4">
              <div class="d-flex align-items-center">
                <label
                  class="mbs-form_label mb-0 mr-2"
                  for="backup-files-modified-since-time-picker"
                  [class.-disabled]="!stepForm.get('backupFilesModifiedSince').value"
                  >{{ 'wizards:time_label' | i18next }}</label
                >
                <mbs-timepicker
                  formControlName="time"
                  [id]="'backup-files-modified-since-time-picker'"
                  [meridian]="true"
                  [needChangeInvalid]="true"></mbs-timepicker>
                <span
                  class="cursor-help fa fa-info-circle text-info ml-2"
                  [ngbTooltip]="'wizards:backup_modified_since_tooltip' | i18next"
                  [placement]="['top-right', 'left', 'auto']"></span>
              </div>
            </div>
          </div>
        </mbs-form-group>

        <mbs-form-group class="mb-0">
          <div class="form-row align-items-center">
            <div class="col-5">
              <mbs-checkbox
                class="mr-2"
                formControlName="doNotBackup"
                [id]="'do-not-backup-files-checkbox'"
                [label]="'wizards:not_backup_large_than_label' | i18next"
                (change)="doNotBackupChangeHandler($event)"></mbs-checkbox>
            </div>
            <div class="col-3">
              <mbs-number
                formControlName="fileSize"
                [id]="'file-size-input-number'"
                [min]="1"></mbs-number>
            </div>
            <div class="col-1">
              <label
                class="mbs-form_label mb-0"
                for="file-size-input-number"
                [class.-disabled]="!stepForm.get('doNotBackup').value"
                >MB</label
              >
            </div>
          </div>
        </mbs-form-group>
      </ng-container>
    </mbs-card-group>

    <mbs-card-group>
      <mbs-form-group class="mb-0">
        <mbs-checkbox
          formControlName="ignoreSystemAndHidden"
          [id]="'ignore-system-hidden-checkbox'"
          [label]="'wizards:not_backup_system_hidden_label' | i18next"></mbs-checkbox>

        <ng-container *ngIf="!linuxLessThat4_2">
          <mbs-checkbox
            formControlName="SkipInUseFiles"
            [id]="'ignore-locked-checkbox'"
            [label]="'wizards:not_backup_locked_label' | i18next"></mbs-checkbox>
        </ng-container>
        <ng-container *ngIf="!isUnix || isNetBuild">
          <mbs-checkbox
            formControlName="ignoreOnDemand"
            [id]="'ignore-on-demand-checkbox'"
            [label]="'wizards:not_backup_demand_label' | i18next">
            <ng-container appendLabel>
              <span
                class="cursor-help fa fa-info-circle text-info ml-2"
                container="body"
                tooltipClass="tooltip-lg"
                [ngbTooltip]="ignoreOnDemandTooltip"></span>
              <ng-template #ignoreOnDemandTooltip>
                <div class="text-start">
                  <span
                    *ngFor="let item of notBackupDemandTooltipTexts; let last = last"
                    [class]="!last ? 'd-block mb-2' : ''">
                    {{ item }}
                  </span>
                </div>
              </ng-template>
            </ng-container>
          </mbs-checkbox>
        </ng-container>
      </mbs-form-group>
    </mbs-card-group>
  </mbs-card>
</section>
